import React from 'react'
import TimelineItem from './TimelineItem'
import green from '../../assets/images/green.svg'
import learn from '../../assets/images/learn.svg'
import timeline1 from '../../assets/images/timeline_1.png'
function Timeline() {
  return (
    <div
      className="pc_timeline"
      style={{ width: '1200px', margin: '0 auto', height: '2600px' }}
    >
      <div classname="pc_timeline_left" style={{ float: 'left', width: '47%' }}>
        <TimelineItem />
        <TimelineItem />
        <TimelineItem />
        <TimelineItem />
      </div>
      <div
        classname="pc_timeline_center"
        style={{ float: 'left', width: '6%' }}
      >
        <div>
          <img src={green} alt="first" />
        </div>
        <div>
          <img src={timeline1} alt="first" />
        </div>
      </div>
      <div
        classname="pc_timeline_right"
        style={{ float: 'left', width: '47%' }}
      >
        <TimelineItem />
        <TimelineItem />
        <TimelineItem />
      </div>
    </div>
  )
}
export default Timeline
